import Logo from '../assets/logo.png'
import React, { useState } from 'react';
import { Link } from 'react-scroll';


function Header() {
    // const handleClick = (event) => {
    //     // 阻止默认行为（不跳转）
    //     event.preventDefault();

    //     // 在这里可以添加你想要的其他操作
    //     // 例如，添加左边框效果
    //     event.target.classList.add('border-l-4', 'border-white');
    //   };
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(null);
    // const links = ['介绍', '人员', '成果',  '联系我们'];
    const links = [
      {
        title: '介绍',
        id: 'intro'
      },
      {
        title: '人员',
        id: 'member'
      },
      {
        title: '成果',
        id: 'work'
      },
      {
        title: '联系我们',
        id: 'contact'
      },
    ]
    const handleHover = (index) => {
      setActiveIndex(index);
    };

    const handleClick = (event, index) => {
        event.preventDefault(); // 阻止默认的提交行为
        setActiveIndex(index);
        // event.target.classList.add('border-l-2', 'border-white');
        setMenuOpen(false);
    // 在这里可以添加其他点击事件的逻辑
    };

    const getDynamicClasses = (index) => {
        return `inline-block px-4 text-white cursor-pointer transition duration-300 transform ${index === activeIndex ? 'hover:translate-x-1': ''}`;
      };

    const renderLinks = () => {

      return links.map((link, index) => (
        <Link
          to={link.id}
          spy={true}
          smooth={true}
          duration={500}
          key={index}
          onMouseEnter={() => handleHover(index)}
          onClick={(event) => handleClick(event, index)}
          className={getDynamicClasses(index)}
          style={{
            boxShadow: index === activeIndex ? '-2px 0 0 white' : 'none', // 产生左边的边框
          }}
        >
          {link.title}
        </Link>
      ));
    };


  return (
    <header className='fixed top-0 left-0 right-0 flex justify-between items-center h-20 bg-[#34623e] px-12 z-30' style={{ borderBottom: '1px solid white' }}>
        <Link  to= 'header'
               spy={true}
               smooth={true}
               duration={500}>
            <img src={Logo} alt="" className='w-10 h-10 cursor-pointer'/>
        </Link>
        <nav className='hidden md:flex items-center font-bold space-x-32 border-b-white-500'>
            {renderLinks()}
        </nav>
        <button
        className="md:hidden text-white"
        onClick={() => setMenuOpen(!isMenuOpen)}
      >
        {/* 汉堡包图标 */}
        {isMenuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="28" height="28">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="28" height="28">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>
         {/* 移动端菜单 */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-20 center bg-[#34623e] py-6 w-5/6 border-2 my-6 rounded-xl  transition-transform duration-300 transform translate-y-0">
          <ul>
            {links.map((link, index) => (
              <li key={index} className='h-12 flex items-center justify-around'>
                <Link
                  to={link.id}
                  spy={true}
                  smooth={true}
                  duration={500}
                  href="#"
                  className='inline-block text-[#aab8c2] font-bold text-center hover:text-white'
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  )
}

export default Header
